module.exports = __webpack_public_path__ + "static/media/logo_abbank.d34b04b8.svg";